import axiosInstance from "@/api/axios";

export default {
  namespaced: true,
  state: {
    allcompetitons: [],
    competitions: [],
    competition: null,
    agencyFollowers: [],
    respectiveCompetition: [],
    agencyDetailedPoints: [],
    competitionResponses: [],
    challengesParticipated: [],
    participatedresponses: [],
    requestsData: [],
    invitationsData: []   // ← ADD THIS
  },
  getters: {
    getAllCompetitions(state) {
      return state.allcompetitons;
    },
    getAgencyCompetitions(state) {
      return state.competitions;
    },
    getAgencyFollowers(state) {
      return state.agencyFollowers;
    },
    competitionTeam(state) {
      return state.competition;
    },
    competitionTeamParticipated(state) {
      return state.competition;
    },
    respondCompetition(state) {
      return state.competition;
    },
    participatedChallenges(state) {
      return state.challengesParticipated;
    },
    agencyDetailedPoints(state) {
      return state.agencyDetailedPoints;
    },
    getParticipatedresponses(state) {
      return state.participatedresponses;
    }
  },
  mutations: {
    setCompetitions(state, data) {
      state.allcompetitons = data;
    },
    eachCompetitions(state, data) {
      state.competitions = data;
    },
    respectiveCompetitions(state, data) {
      state.respectiveCompetition = data;
    },
    individualResponses(state, data) {
      state.competitionResponses.push(data);
    },
    setAgencyFollowers(state, data) {
      state.agencyFollowers = data;
    },
    addCompetition(state, data) {
      const item = state.competitions.find(item => item._id === data._id);
      if (item) {
        Object.assign(item, data);
      } else {
        state.competitions.unshift(data);
      }
    },
    setPartcipatedChallenges(state, data) {
          state.challengesParticipated = data;
    },
     setRequestsData(state, data) {
    state.requestsData = data;
  },
    setInvitationsData(state, data) {
  state.invitationsData = data;
},
    editCompetition(state, data) {
      const item = state.competitions.find(item => item._id === data._id);
      if (item) {
        Object.assign(item, data);
      }
    },
    setCompetition(state, competition) {
      state.competition = competition;
    },
    REMOVE_COMPETITION(state, competitionId) {
      state.competitions = state.competitions.filter(
        competition => competition._id !== competitionId._id
      );
    },
    respondCompetition(state, competitionTeam) {
      state.competition = competitionTeam;
    },
    agencyDetailedPoints(state, agencyDetails) {
      state.agencyDetailedPoints = agencyDetails;
    },
    participatedresponses(state, responses) {
      state.participatedresponses = responses;
    }
  },
  actions: {
    fetchAllCompetitions({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .get("competition/getAllCompetitions")
          .then(res => {
            if (res.data.competitions) {
              commit("setCompetitions", res.data.competitions);
              resolve(res.data.competitions);
            } else {
              reject(new Error(res.data.message));
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    fetchEachCompetitions({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .get("competition/getAgencyCompetitions")
          .then(res => {
            if (res.data.status === true) {
              commit("eachCompetitions", res.data.competitions);
              resolve(res.data.competitions);
            } else {
              reject(new Error(res.data.message));
            }
          })
          .catch(error => {
            reject(
              new Error(
                error.response?.data?.message ||
                  `Failed to fetch agency competitions: ${error.message}`
              )
            );
          });
      });
    },
    respectiveCompetition({ commit, rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("competitionTeam/getCompetitionTeamsByCompetitionId", params, {
            Authorization: rootState.auth.token
          })
          .then(res => {
            if (res.data.competition_detailedView) {
              commit(
                "respectiveCompetitions",
                res.data.competition_detailedView
              );
              resolve(res.data.competition_detailedView);
            } else {
              reject(new Error(res.data.message));
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getIndividualResponses({ commit, rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("competition/getIndividualResponses", params, {
            Authorization: rootState.auth.token
          })
          .then(res => {
            if (res.data.responses) {
              commit("individualResponses", res.data.responses);
              resolve(res.data.responses);
            } else {
              reject(new Error(res.data.message));
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getCompetition({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .get("competition/getAgencyFollowers", {
            Authorization: rootState.auth.token
          })
          .then(res => {
            if (res.data.success == true || res.data.followers) {
              commit("setAgencyFollowers", res.data.followers);
              resolve(res.data.followers);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    addCompetition({ commit, rootState, dispatch }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("competition/createCompetition", params, {
            Authorization: rootState.auth.token
          })
          .then(res => {
            if (res.data.competition) {
              commit("addCompetition", res.data.competition);
              dispatch("fetchEachCompetitions").then(() => {
                resolve(res.data.competition);
              }); // Fetch all competitions to refresh the data
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    editCompetition({ commit, rootState, dispatch }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("competition/updateCompetition", params, {
            Authorization: rootState.auth.token
          })
          .then(res => {
            if (res.data.competition) {
              commit("editCompetition", res.data.competition);
              dispatch("fetchEachCompetitions");
              resolve(res.data.competition);
            } else {
              reject(new Error(res.data.message));
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // detailedCompetition({ commit, rootState }, params) {
    //   return new Promise((resolve, reject) => {
    //     axiosInstance(rootState.auth.token)
    //       .post("competitionTeam/getCompetitionTeamsByCompetitionId", params, {
    //         Authorization: rootState.auth.token
    //       })
    //       .then(res => {
    //         if (res.data.competition_detailedView) {
    //           commit("setCompetition", res.data.competition_detailedView);
    //           resolve(res.data.competition_detailedView);
    //         } else {
    //           reject(res.data.message);
    //         }
    //       })
    //       .catch(error => {
    //         reject(error);
    //       });
    //   });
    // },
    deleteCompetition({ commit, rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("competition/deleteCompetition", params, {
            Authorization: rootState.auth.token
          })
          .then(res => {
            if (res.data.success === true) {
              commit("REMOVE_COMPETITION", params.competitionId);
              resolve(res.data.message);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
   getCompetitionTeamInvitation({ commit, rootState }) {
  return new Promise((resolve, reject) => {
    axiosInstance(rootState.auth.token)
      .get("competitionTeam/getCompetitionTeamInvitation")
      .then(res => {
        if (res.data.status && res.data.data) {
          commit("setInvitationsData", res.data.data);  // ← FIXED (was "competitionTeam")
          resolve(res.data.data);
        } else {
          reject(new Error(res.data.message || "No competition teams found for the given agency ID."));
        }
      })
      .catch(error => {
        reject(new Error(error.response?.data?.message || `Failed to fetch competition team invitation: ${error.message}`));
      });
  });
},
    fetchRequests({ commit, rootState }) {
    return new Promise((resolve, reject) => {
      axiosInstance(rootState.auth.token)
        .get("competitionTeam/requestedChallenges", { // Use the endpoint you showed
          Authorization: rootState.auth.token
        })
        .then(res => {
          if (res.data.status && res.data.data) {
            commit("setRequestsData", res.data.data);
            resolve(res.data.data);
          } else {
            reject(
              new Error(
                res.data.message || "No requests found."
              )
            );
          }
        })
        .catch(error => {
          reject(
            new Error(
              error.response?.data?.message ||
                `Failed to fetch requests: ${error.message}`
            )
          );
        });
    });
  },
    getParticipatedCompetitionTeam({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .get("competitionTeam/getParticipatedCompetitionTeam", {
            Authorization: rootState.auth.token
          })
          .then(res => {
            if (res.data.data) {
              commit("competitionTeamParticipated", res.data.data);
              resolve(res.data.data);
            } else {
              reject(
                new Error(
                  res.data.message ||
                    "No competition teams found for the given agency ID."
                )
              );
            }
          })
          .catch(error => {
            reject(
              new Error(
                error.response?.data?.message ||
                  `Failed to fetch competition team invitation: ${error.message}`
              )
            );
          });
      });
    },
    respondToCompetitionRequest({ commit, rootState }, params) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("competitionTeam/respondToCompetitionRequest", params, {
            Authorization: rootState.auth.token
          })
          .then(res => {
            if (res.data.status === true) {
              commit("respondCompetition", res.data.competitionTeam);
              resolve(res.data.competitionTeam);
              if (!res.data.status) {
                reject(res.data.message);
              }
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    fetchParticipatedChallenges({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("competition/participatedChallenges") // No payload sent
          .then(res => {
            if (res.data.success === true) {
              commit(
                "setPartcipatedChallenges",
                res.data.participatedChallenges
              );
              resolve(res.data.participatedChallenges);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getCompetitionDetailedPoints({ commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("competition/allAgencyCompetitionPoints", payload, {
            Authorization: rootState.auth.token
          })
          .then(res => {
            if (res.data.status === true) {
              commit("respondCompetition", res.data.agencyDetails);
              resolve(res.data.agencyDetails);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getParticipatedResponses({ commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("competition/getParticipatedResponses", payload, {
            Authorization: rootState.auth.token
          })
          .then(res => {
            if (res.data.success === true) {
              commit("participatedresponses", res.data.responses);
              resolve(res.data.responses);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    checkUserExistinCompetition({ rootState }) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .get("competition/check-exist", {
            headers: {
              Authorization: rootState.auth.token
            }
          })
          .then(res => {
            if (res.data.success === true) {
              resolve(res.data.alreadyInCompetition);
            } else {
              reject(res.data.message || "Check failed");
            }
          })
          .catch(error => {
            reject(error.response?.data?.message || error.message);
          });
      });
    },
    approveParticipatedUsers({ rootState }, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("competition/approveParticipatedUsers", payload, {
            headers: {
              Authorization: rootState.auth.token
            }
          })
          .then(res => {
            if (res.data.success === true) {
              resolve(res.data.message);
            } else {
              reject(res.data.message || "Approval failed");
            }
          })
          .catch(error => {
            reject(error.response?.data?.message || error.message);
          });
      });
    },
    rejectParticipatedUsers({ rootState }, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("competition/rejectParticipatedUsers", payload, {
            headers: {
              Authorization: rootState.auth.token
            }
          })
          .then(res => {
            if (res.data.success === true) {
              resolve(res.data.message);
            } else {
              reject(res.data.message || "Rejection failed");
            }
          })
          .catch(error => {
            reject(error.response?.data?.message || error.message);
          });
      });
    },
    approveParticipatedAgencies({ rootState }, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("competition/approveParticipatedAgencies", payload, {
            headers: {
              Authorization: rootState.auth.token
            }
          })
          .then(res => {
            if (res.data.success === true) {
              resolve(res.data.message);
            } else {
              reject(res.data.message || "Approval failed");
            }
          })
          .catch(error => {
            reject(error.response?.data?.message || error.message);
          });
      });
    },
    rejectParticipatedAgencies({ rootState }, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("competition/rejectParticipatedAgencies", payload, {
            headers: {
              Authorization: rootState.auth.token
            }
          })
          .then(res => {
            if (res.data.success === true) {
              resolve(res.data.message);
            } else {
              reject(res.data.message || "Rejection failed");
            }
          })
          .catch(error => {
            reject(error.response?.data?.message || error.message);
          });
      });
    },
    topScores({ rootState }, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("competition/getTop5Scores", payload, {
            headers: {
              Authorization: rootState.auth.token
            }
          })
          .then(res => {
            if (res.data.success === true) {
              resolve(res.data.allscores);
            } else {
              reject(res.data.message || "Failed to fetch top scores");
            }
          })
          .catch(error => {
            reject(error.response?.data?.message || error.message);
          });
      });
      
    },
    // all volunteer scroes for respective competition
    allVolunteerScores({ rootState }, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("competition/getAllvounteerScores", payload, {
            headers: {
              Authorization: rootState.auth.token
            }
          })
          .then(res => {
            if (res.data.success === true) {
              resolve(res.data.competitonScoreData);
            } else {
              reject(res.data.message || "Failed to fetch volunteer scores");
            }
          })
          .catch(error => {
            reject(error.response?.data?.message || error.message);
          });
      });
    },
    // all agency scroes for respective competition
    allAgencyScores({ rootState }, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("competition/getAllagencyScores", payload, {
            headers: {
              Authorization: rootState.auth.token
            }
          })
          .then(res => {
            if (res.data.success === true) {
              resolve(res.data.competitonScoreData);
            } else {
              reject(res.data.message || "Failed to fetch volunteer scores");
            }
          })
          .catch(error => {
            reject(error.response?.data?.message || error.message);
          });
      });
    },

    // addAgencyInCompetition
    addAgencyInCompetition({ rootState }, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("competition/addAgencyInCompetition", payload, {
            headers: {
              Authorization: rootState.auth.token
            }
          })
          .then(res => {
            if (res.data.success === true) {
              resolve(res.data.message);
            } else {
              reject(res.data.message || "Failed to add agency in competition");
            }
          })
          .catch(error => {
            reject(error.response?.data?.message || error.message);
          });
      });
    } 
  }
};
